
import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { AppUrl } from '../constants/app-urls';
import { Appointment } from '../models/appointment.model';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

@Injectable({
  providedIn: 'root',
})
export class CommonService {
    //loggedIn = false;
  constructor(private http: HttpClient) {}

  addNewAppointment(appointment: Appointment): Observable<any>{ 
    return this.http.post<any>(
        AppUrl.appointments+"/new", 
        appointment, 
        httpOptions );
  }
  
  updateAppointment(appointment: Appointment): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.appointments+"/"+appointment.id+"/update", 
      appointment,
      httpOptions );  
  }

  updateAppointmentStatus(appointmentId: number, status: string): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.appointments+"/"+appointmentId+"/update-status", 
      {data: status},
      //status,
      httpOptions );  
  }

  rescheduleAppointment(appointmentId: number, rescDate: string): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.appointments+"/"+appointmentId+"/reschedule", 
      {dateTime: rescDate},
      httpOptions );  
  }

  fetchMyAppointments(): Observable<any>{ 
    return this.http.get<any>(
      AppUrl.appointments+"/my", 
      httpOptions 
    );
  }

  fetchMyConversations(): Observable<any>{ 
    return this.http.get<any>(
      AppUrl.conversations+"/my", 
      httpOptions 
    );
  }
  
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
